// src/components/AgePyramidChart.js
import React from "react";
import { locales } from "../../locales";
import { formatNumber } from "../../utils/communesUtils";

const AgePyramidChart = ({ data, langId }) => {
  const aggregateData = (data) => {
    const newData = {
      "0_20": { m: 0, f: 0 },
      "20_40": { m: 0, f: 0 },
      "40_60": { m: 0, f: 0 },
      "60_80": { m: 0, f: 0 },
      "80_100": { m: 0, f: 0 },
      "100+": { m: 0, f: 0 },
    };

    Object.entries(data).forEach(([ageRange, { m, f }]) => {
      const age = parseInt(ageRange.split("_")[0], 10);
      let targetRange;

      if (age < 20) {
        targetRange = "0_20";
      } else if (age < 40) {
        targetRange = "20_40";
      } else if (age < 60) {
        targetRange = "40_60";
      } else if (age < 80) {
        targetRange = "60_80";
      } else if (age < 100) {
        targetRange = "80_100";
      } else {
        targetRange = "100+";
      }

      newData[targetRange].m += m;
      newData[targetRange].f += f;
    });

    return newData;
  };

  const newData = aggregateData(data);
  const maxValue = Math.max(
    ...Object.values(newData).map((obj) => Math.max(obj.m, obj.f))
  );
  const barHeight = 38;
  const maxBarWidth = 280;

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-center">
        <div className="w-[328px] mr-2 flex justify-end">
          {locales[langId].gender.women}
        </div>
        <div className="w-[250px]">{locales[langId].gender.men}</div>
      </div>
      {Object.entries(newData).map(([ageRange, { m, f }]) => (
        <div key={ageRange} className="flex">
          <div className="flex items-center justify-start w-[90px]">
            <span className="text-xs font-bold leading-[14px]">
              {ageRange.replace("_", "-").indexOf("+") > -1
                ? ageRange.replace("_", "-")
                : ageRange.replace("_", "-") + " " + locales[langId].years}
            </span>
          </div>
          <div className="flex items-center justify-center h-[38px] bg-wort-background mb-2 w-full">
            <div className="flex items-center justify-end w-1/2 mr-2">
              <div
                className="bg-[#E88B00] flex items-center justify-end pr-2"
                style={{
                  height: `${barHeight}px`,
                  width: `${((f / maxValue) * maxBarWidth) / 2}px`,
                }}
              >
                <span>{formatNumber(newData[ageRange].f)}</span>
              </div>
            </div>
            <div className="flex items-center justify-start w-1/2">
              <div
                className="bg-[#86CDEB] flex items-center justify-start pl-2"
                style={{
                  height: `${barHeight}px`,
                  width: `${((m / maxValue) * maxBarWidth) / 2}px`,
                }}
              >
                <span>{formatNumber(newData[ageRange].m)}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AgePyramidChart;
